exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-pc[data-v-b4bdc92c] {\n  height: auto !important;\n  width: 100% !important;\n  max-width: 19.2rem !important;\n  min-width: 12rem !important;\n  margin: auto;\n}\n.page-pc-child[data-v-b4bdc92c] {\n  width: 100%;\n  min-width: 12rem !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/vue-loader/lib/loaders/stylePostLoader.js!./~/postcss-loader/src?{"path":"/Users/admin/Documents/futu-code/postcss.config.js"}!./~/less-loader!./~/vue-loader/lib?{}!./src/render/index.vue?vue&type=style&index=0&id=b4bdc92c&lang=less&scoped=true&
// module id = 145
// module chunks = 0